var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599976,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0792 18.8333L15.7458 17.5H4.76666C4.30833 17.5 3.91597 17.3368 3.58958 17.0104C3.26319 16.684 3.1 16.2917 3.1 15.8333V4.85418L1.76666 3.50001L2.93333 2.33334L18.2667 17.6667L17.0792 18.8333ZM4.76666 15.8333H14.0792L4.76666 6.52084V15.8333ZM18.1 15.1458L16.4333 13.4792V6.66668H9.62083L5.45416 2.50001H16.4333C16.8917 2.50001 17.284 2.6632 17.6104 2.98959C17.9368 3.31598 18.1 3.70834 18.1 4.16668V15.1458Z",
    fill: "#5F656D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDisabled);
export default __webpack_public_path__ + "static/media/calendar-disabled.9ed24dc872039693ce2d669fbe28ba7e.svg";
export { ForwardRef as ReactComponent };